import React from 'react';
import './Policy.css';

import { PageTitle } from '../../../components';

import { Button, Heading } from '../../../components';
import { images } from '../../../constants'; 
import { FaBuilding, FaTools } from 'react-icons/fa';



const RefundPolicy = () => { 
  return ( 
    <>  
      {/* Page title */}
      <PageTitle title={'服務條款/隱私權政策'} page={'Rule and Privacy'} />
          <section className='refund-policy'>
            
            {/* About section */}
            <section className='about'> 

            <div className='box-container'>

              {/* About images */}
              
      
              {/* About description */}
              <div className='content'> 
                <Heading title={'服務條款'} subTitle={'Rules of Service'} />
                <p>順康資產管理顧問有限公司（以下簡稱「本公司」）係依據本條款，提供「10 Parking LINE@」服務向使用者（以下簡稱「您」或「會員」）（以下簡稱「本服務」）之會員服務。</p>
                <p>當您加入會員以會員帳號實際使用本服務時，即表示您已閱讀、瞭解並同意接受本約定。如果您經過考慮後不同意本條款的內容，請您不要完成加入程序，如已加入時，請您通知本公司終止您的會員資格並停止使用本服務。若您未滿二十歲，或為法令規定未具備完全行為能力之人，請您由家長（或監護人）陪同閱讀本條款，在您的家長（或監護人）詳讀、瞭解並同意後，您才能使用或繼續使用本服務。當您使用或繼續使用本服務時，即推定您的家長（或監護人）已詳讀、瞭解並同意接受本條款的所有內容及其後修改變更。</p> {/* Description */}
                <ul className='about-points'> 
                  <li>
                    {/* <FaBuilding className='icon' />  */}
                    {/* Building icon */}
                    <div className='text'>
                      <div className="policyTitle">一、服務條款</div> {/* Construction title */}
                      <div className="text-list">
                      <ol>
                        <li>1. 本公司之 10 Parking LINE@ 服務，提供成功加入 10 Parking LINE@ 帳戶之會員，得利用信用卡及其他支付方法（包括第三方支付帳號、簽帳金融卡「Debit Card」、約定帳戶扣款）（下稱「支付方法」），作為向與本公司合作之商家，給付因消費停車、充電或其他與出行相關的周邊服務，所生的消費對價的方法。  </li>
                        <li>2. 您瞭解本服務之功能，並在加入會員時，同意本服務傳送服務性或商業性資料供您參考，包括但不限於下列事項（您能隨時能利用手機或本服務內建之功能，停止接收這些資料）： 
                            <div className='subList'>- 本服務將提供您所在地區合作對象的消費資訊，除所在位置、各點營業時間、收費與付款方式外，另不定期以行動推播之方式，分享合作對象的優惠消息。</div>
                            <div className='subList'>- 如您於會員資料中提供您的支付方法，本服務將以前述方式，提供各支付方法之優惠訊息，優惠訊息包含但不限於各公開網站可搜集到資料。</div>
                            <div className='subList'>- 如您於會員資料中提供您的車號資訊，本服務將以前述方式，提供相對應的會員優惠，會員優惠將適用於與本服務中合作之服務場所。</div>
                         
                        </li>
                        <li>3. 如您不同意本條款所載之任何內容，即不應使用本服務或加入為會員。本公司得隨時依業務推展及消費者需求，自主決定增加、修改或向會員終止本條款。但於增加或修改本條款之情形本公司應將修訂後之條款刊登於官方 FaceBook 及 LINE@，或以其他方式通知會員，如您不同意本條款之變更內容，應於收受通知後的3日內向本公司提出，如未提出，本條款的變更內容將於刊登在官方 FaceBook 及 LINE@ 之日，或以其他方式通知會員時生效。</li>
                        </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />   */}
                    {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">二、個人資料安全</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                          <li>1. 為了提供確實有效的服務，您必須保證在加入成為會員時所留存的所有資料均為完整、正確、與當時情況相符的資料。若您留存之資料非屬您本人所有，例如第三人所有之車輛資料，您在此擔保您已獲有相應且充分之授權。如果事後有變更，為了確保您的權利，您應該即時修改本網站留存之會員資料。若您提供任何錯誤或不實、或未經授權的資料，除您必須自行負擔因此造成的全部損失外（包含但不限於本公司受第三人求償之損失），本服務並有權暫停或終止您的帳號，並拒絕您繼續使用本服務。  </li>
                          <li>2. 您所填寫個人資料如有重複、冒用他人名義、違反公序良俗、或有侵害他人姓名權、公司名稱、商標或其他智慧財產權之虞、或有造成他人誤解之虞、或涉有其他違反法令之嫌、或侵害本公司權利的情況，本公司得要求您更正為正確、合法、妥適之資料，或暫停、終止您的會員資格及相關權利，並且，您應自負一切民事與刑事上之責任。  </li>
                          <li>3. 對於您所留存的資料，其目的在於提高會員資料真實性，提供更佳的服務與優惠。本服務遵守中華民國個人資料保護法令相關規定之規範，除了可能涉及違法、侵權、或違反使用條款、或提供顧客服務而提供給服務之配合廠商、或經本人同意以外，這些資料將只提供本公司於隱私權政策的範圍內，進行利用，絕不會任意透露、出售、交換、或出租給其他第三人、單位及團體；如不同意前揭個人資料之利用，將無法享有本公司或本公司與第三人合作提供之相關權益及優惠。在您同意上述資料蒐集後，仍可依據隱私權政策的有關規定，向本公司申請變更、刪除或停止利用資料中包含您個人資料的部份。具體規範，請參考本公司的隱私權政策。隱私權政策之內容，為本條款之一部分，皆對會員有拘束力。</li>
                      </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">三、帳號保管義務</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                          <li>1. 會員卡號僅限會員本人使用，會員僅得依本條款使用本服務，不得非法重製、散布、販賣、公開傳輸或以其他方式給其他第三人使用。  </li>
                          <li>2. 會員有義務妥善保管會員卡號、車號、密碼及其他相關資訊，並為此組卡號、車號登入系統後所進行之一切活動、行為負責，並負擔因利用會員卡號所衍生之一切相關費用。  </li>
                          <li>3. 若會員發現帳號內個人資料遭他人非法使用或有任何異常使用之情形時，應立即通知本公司，並請您循適當法律途徑保護個人權益；必要時，本公司會請會員提供相關個人資料，並有權管理該爭議帳戶之使用權限。  </li>
                          <li>4. 如因會員保管疏忽或同意由第三人使用其會員卡號，導致會員卡號、車號、密碼遭他人非法使用，造成本公司或其他會員權益損害時，將自行負責相關法律及損害賠償責任。</li>
                      </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">四、智慧財產權</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                        <li>1. 本服務內提供的任何資訊內容，包括但不限於文字、美術作品、圖標、圖像及商標，乃至本服務軟體的功能介面呈現，均係順康資產管理顧問有限公司擁有的智慧財產權，受到中華民國法律所保護。在未得到順康資產管理顧問有限公司發出的事先書面許可前，您不得以任何方式就任何目的將本服務的內容或其任何部份進行重製、拷貝、出售、交易、轉售其內容或作任何商業目的之使用，並同意不會移除或變更本服務的內容中所包含的任何防盜拷措施，或其它權利保護措施（包括且不限於專利權、商標權）或標記；惟您可將本服務之資訊內容，在基於非商業性、家居及個人使用的目的範圍內，自行利用，但仍應確保本公司之智慧財產權不受第三人之侵害。  </li>
                        <li>2. 本公司僅授權您使用本服務，而並非將本服務所提供的內容、文字檔及任何編碼的智慧財產權移轉給您。為免存疑，一切本公司沒有在本條款中明確授予您的權利，均由本公司保留。</li>
                      </ol>

                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">五、付款流程與確認機制</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                      <li>1. 本服務將登錄使用者之會員卡號、車牌號碼、手機號碼及支付方法，作為認定會員使用服務的依據。  </li>
                      <li>2. 多組車牌號碼將綁定一張或多張特定之信用卡、第三方支付帳戶或其他支付方法（以下合稱「綁定之付款方式」），進行請款處理；會員綁定車號時，即同意授權本服務得依據會員需求，建立會員訂單，並依據會員之消費記錄（支付明細），向會員綁定之付款方式進行請款。  </li>
                      <li>3. 當綁定的車號進入本公司的服務場域時，本服務將設定訂單產生之時間，而當綁定的車號離開前述場域，本服務將取得訂單完成時間，並即時發送消費記錄（支付明細）至會員登記之 LINE@，該次訂單即視為完成。本服務亦會將歷次會員使用服務的消費記錄(支付明細)，顯示於目前停車頁面中，會員並可透過本服務隨時查詢，亦可透過設定隨時取消綁定。  </li>
                      <li>4. 如您的訂單因任何因素而無法成功由您綁定之付款方式為成功扣款時（以下簡稱「扣款失敗」），本公司將進行以下催繳程序：  
                        <div className='subList'>- 本公司將於知悉該筆訂單扣款失敗時，以 LINE@ 之方式書面通知您，並請您盡快綁定其他有效之付款方式，以茲本公司於您變更後之翌日完成扣款。  </div>
                        <div className='subList'>- 本公司向您發出前揭書面通知後 5 日內，您的訂單若仍扣款失敗，本公司將暫停對您提供本服務之全部或任何部分。  </div>
                        <div className='subList'>- 承上，本公司之指定人員將以 LINE@ 與您聯繫該筆扣款失敗之債務催繳事宜，並將請您於指定期限內清償債務，若未如期繳納，本公司將於前揭期滿之日起按年利率百分之五加收遲延利息。</div>
                      </li>
                      </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">六、消費記錄與優惠認定</div> {/* Maintenance title */}
                      <div className="text-list">
                        <ol>
                          <li>1. 本服務所產生的消費記錄，將依據車主進入合作服務場域的時間，生成訂單編號，會員可依消費記錄了解本身付款狀況。</li>
                          <li>2. 會員所累積之優惠，可於期限內於本服務使用；使用期間之認定，依照本公司伺服器收到訂單完成而送出請款請求之時間為準。</li>
                          <li>3. 若因任何因素（不可抗力除外）造成場域傳送延誤，使得優惠無法使用，本公司概不負責。</li>
                        </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">七、錯誤支付之處理</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                        <li>1. 因不可歸責會員之事由而發生支付錯誤之情況時（例如：車牌號碼、信用卡或帳號等資訊遭盜用，或其他軟硬體之技術問題造成訂單不應產生卻完成支付流程等等）本公司應協助會員進行更正，並提供必要之協助，且得視具體情況先行停止交易或凍結會員帳號之使用。  </li>
                        <li>2. 因可歸責於本公司之事由而發生支付錯誤之情況時，本公司將於知悉時進行即時更正，並以  LINE@ 之方式向會員進行通知。  </li>
                        <li>3. 因可歸責於會員之事由而發生支付錯誤之情況時，會員有即時通知本公司之義務，本公司將於知悉後協助會員進行必要之處理。</li>
                      </ol>

                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">八、禁止行為</div> {/* Maintenance title */}
                      <div className="text-list">
                      <p>會員聲明並保證，不會從事以下行為或符合以下描述（下稱「禁止行為」）：</p>
                      <ol>
                        <li>1. 違反本條款或任何適用於本服務之政策、規範或其他與會員間之約定；  </li>
                        <li>2. 使用本服務時違反任何法律、法規命令（包括任何反洗錢或反資助恐怖主義之法律或法令）、行政指導，或法院判決與主管機關之處分；  </li>
                        <li>3. 以危害公序良俗之方式使用本服務；  </li>
                        <li>4. 以侵害本公司或第三人之權利之方式使用本服務；  </li>
                        <li>5. 以他人名義加入 10 Parking LINE@；使用偽造、不正確或誤導之資訊加入本服務、取得並使用多個 10 Parking LINE@ 帳戶；允許非該會員本人之人使用 10 Parking LINE@ 帳戶；  </li>
                        <li>6. 未經本公司事前同意，利用本服務作為交易其他商品或服務之對價；  </li>
                        <li>7. 利用本服務從事詐欺或其他非法交易；  </li>
                        <li>8. 使用無效的或他人的金融機構帳號（包括信用卡帳號）加入會員；  </li>
                        <li>9. 透過本服務購買法律或國際信用卡組織禁止或限制之物品或服務，或購買仿冒品；  </li>
                        <li>10. 干擾本服務之電腦伺服器或網路系統；  </li>
                        <li>11. 使用不適當之技術方法操控本服務；  </li>
                        <li>12. 複製、改造或公開傳輸本公司為提供本服務所使用之軟體、程式、資料庫及應用程式介面（API）（但不包括因使用本服務所需之公開傳輸），及使用逆向工程、拆解或其他方法以分析上開軟體、程式、資料庫及應用程式介面（API）。  </li>
                        <li>13. 經本公司合理要求並說明目的，拒絕配合調查、確認身份或提供文件以佐證提供予本公司之資訊；  </li>
                        <li>14. 控制 10 Parking LINE@ 帳戶，該帳戶係與另一從事禁止行為之 10 Parking LINE@ 帳戶相連結；  </li>
                        <li>15. 以會導致或可能導致本公司，以及包含其他會員、本公司之合作廠商在內之第三人遭申訴、告訴、訴訟罰鍰、處分或負擔其他法律責任之方式，使用本服務；  </li>
                        <li>16. 曾經信用評等機構評定會員使用本服務為高風險；  </li>
                        <li>17. 自信用卡預借現金（或協助他人為之）；  </li>
                        <li>18. 會員係因故意或過失而未向本公司（含合作服務場域）清償其所負之債務時。  </li>
                        <li>19. 其他妨礙本服務之正常營運；或從事對本公司造成損害或有損害之虞的任何不當行為。</li>
                      </ol>
                      <p>如會員違反本條款之內容者，本公司得不經催告，隨時暫停對該會員提供本服務之全部或任何部分，並得終止本條款。會員如因違反本條款之行為，造成本公司任何損失或損害，會員並應賠償本公司。  </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">九、被盜用之帳號及密碼之處理</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                        <li>1. 會員一旦發現或懷疑其 10 Parking LINE@ 帳戶或密碼被盜用，或被任何第三人以未經授權之方式使用，使用者應依照本服務登載之聯繫方式，通知本公司並停用爭議帳戶，以使本公司得就此採取適當且及時之措施。惟本公司所採取之該等措施，不應被視為本公司對使用者明示或默示之賠償，亦不應被視為本公司應對使用者負擔任何責任。  </li>
                        <li>2. 於知悉 10 Parking LINE@ 會員帳戶或密碼被盜用，或被任何第三人以未經授權之方式使用時，本公司應立即通知使用者（但如係收受使用者通知而知悉者，即毋須再通知使用者），且暫停 10 Parking LINE@ 帳戶任何已經指示之付款，並停止接受該 10 Parking LINE@ 帳戶後續之任何支付指示。  </li>
                        <li>3. 於本公司受理完成使用者的帳號停用手續後，因該帳號所發生之損失，由本公司負擔；在完成帳號停用手續前，如因下列原因致該帳號發生損失，該損失應由使用者自行負擔：  
                          <div className='subList'>- 使用者未妥善保管帳號密碼</div>
                          <div className='subList'>- 使用者自行將帳號密碼提供與他人</div>
                          <div className='subList'>- 使用者未依照本公司帳號安全機制使用本服務</div>
                          <div className='subList'>- 其他因使用者故意或重大過失所致之事由</div>
                        </li>
                        <li>4. 調查使用者帳號密碼被盜用所生之費用，應由本公司負擔。</li>
                      </ol>

                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">十、資訊安全措施</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                        <li>1. 本公司將定期進行系統更新，並維護本服務所蒐集之會員資訊，防止第三人非法入侵、取得、竄改、毀損交易記錄或其個人資料。因上述情形而造成對會員之損害，如可歸責於本公司時，會員同意以另行協商之方式，決定雙方負擔之比例。  </li>
                        <li>2. 前項情況經查證屬實，本公司得視具體情況，凍結會員帳戶之使用。</li>
                      </ol>

                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">十一、免責聲明</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                        <li>1. 在準備、蒐集本服務所提供資料的過程中，本公司已經盡最大可能採取謹慎的態度，但還是提醒您，除可歸責於本公司之情形外，本公司不會因任何資料的錯誤或遺漏，或因您信賴本服務或其介面上之說明而對提供資料所造成的損害，承擔契約責任。  </li>
                        <li>2. 除本約定書另有規定外，在任何情況下，本公司不對下列損失負擔損害賠償責任：包括因使用或無法使用本服務而引起的利益損失，或其它直接、間接、意外、特別或衍生性的損失（包括但不限於純粹經濟上的損害、生意中斷、生意資訊的遺失、和任何其它金錢上的損失）。於任何情況下，本公司應承擔之契約責任，以所受損害為限，並不包含所失利益。</li>
                      </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">十二、與本公司之爭議</div> {/* Maintenance title */}
                      <div className="text-list">
                        <ol>
                          <li>1. 如使用者依破產法令開始任何程序，或經他人依破產法令提起任何程序，本公司應有權請求執行本條款所生之所有合理的成本及費用（包括合理的律師費及費用）。  </li>
                          <li>2. 如使用者與一個或多個使用者或與本公司之合作廠商有爭議，使用者應使本公司免於該爭議所生或與該爭議相關之任何種類及性質之請求，以及因此可能衍生的任何損害。</li>
                        </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                      <div className="policyTitle">十三、準據法與管轄法院</div> {/* Maintenance title */}
                      <div className="text-list">
                        <p>本約定書之解釋與適用，以及與本約定書有關的爭議，均以中華民國法律為準據法，並以台北地方法院為一審管轄法院。</p>

                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">十四、企業經營者資訊</div> {/* Maintenance title */}
                      <div className="text-list">
                        <p>本服務之擁有者為順康資產管理顧問有限公司 聯絡方式：<a href="mailto:parkingservice@10parking.com">parkingservice@10parking.com</a></p>
                      </div>
                    </div>
                  </li>
                  {/* complete all list */}
                </ul>
                {/* <Button link={'About-us'} title={'learn more'} /> About-Us Button */}
                <Heading title={'隱私權條款'} subTitle={'Privacy Policy}'} />
                <p>順康資產管理顧問有限公司（以下簡稱「本公司」）係依據本條款，提供「10 Parking LINE@」（包含但不限於網頁與行動App）之會員服務（以下簡稱「本服務」）。</p>
                <p>為了保障您的權益，請您務必詳讀本條款，以知悉並瞭解我們蒐集、處理、利用及揭露您的個人資料之目的。  </p> {/* Description */}
                <ul className='about-points'> 
                  <li>
                    {/* <FaBuilding className='icon' />  */}
                    {/* Building icon */}
                    <div className='text'>
                      <div className="policyTitle">一、 個人資料的蒐集目的</div> {/* Construction title */}
                      <div className="text-list">
                        <ol>
                          <li>1. 當您加入 10 Parking LINE@ 會員以使用本服務，本公司將透過隱私權保護政策，蒐集、處理並利用您的個人資料，包含姓名、電話號碼、會員卡號、使用車輛資料（包括但不限於廠牌型號、車牌號碼、車色、外觀影像等）、證件資料（包括但不限於駕駛執照、行車執照等及其所載資訊和外觀影像等）、車輛位置資訊、與其使用本服務相關之交易資訊（包括但不限於信用卡資訊等），及其他與本服務相關而得直接或間接識別使用者身分之資料（以下合稱「個人資料」）。（上述特定目的，法定編號包含：〇四〇 行銷、〇六三 非公務機關依法定義務所進行個人資料之蒐集處理及利用、〇六七 信用卡、現金卡、轉帳卡或電子票證業務、〇六九 契約、類似契約或其他法律關係事務、〇八一 個人資料之合法交易業務、〇九〇 消費者、客戶管理與服務、〇九一 消費者保護、〇九八 商業與技術資訊、一三五 資（通）訊服務、一三六 資（通）訊與資料庫管理、一四八 網路購物及其他電子商務服務、一五二 廣告或商業行為管理、一五七 調查、統計與研究分析、一八一 其他經營合於營業登記項目或組織章程所定之業務。  </li>
                          <li>2. 當您選擇透過本服務以信用卡或任何支付方式付款時，本公司將會要求提供信用卡資訊或任何支付方式資訊以處理該項付款，並提供信用卡或任何支付方式之資訊及其他個人資料予需處理該付款之其他公司。  </li>
                          <li>3. 您得自行決定是否提供本公司所要求之任何個人資料。您應確保其提供予本公司之所有個人資料係完整、準確、真實且正確。如未依上述要求提供個人資料，可能導致您無法繼續使用本服務。</li>
                        </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />   */}
                    {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">二、 個人資料的取得</div> {/* Maintenance title */}
                      <div className="text-list">
                      <ol>
                        <li>1. 當您加入成為本服務之會員時，會要求您輸入手機號碼與電子信箱。  </li>
                        <li>2. 當您在使用本服務時，本公司可能會蒐集到以下資料：  
                            <div className='subList'>- 得以辨識您個人之資料，例如：姓名、住址、電話號碼、電子郵件地址、網路服務帳號、電子簽章、憑證序號、提供網路身分認證或申辦查詢服務之記錄及其他任何可辨識資料本人者。  </div>
                            <div className='subList'>- 得以辨識您財務之資料，例如：金融機構帳戶之號碼與姓名、信用卡或簽帳卡之號碼、保險單號碼、個人之其他號碼或帳戶等。</div>
                            <div className='subList'>- 政府資料得以辨識個人者，例如：身分證統一編號、統一證號、稅籍編號、保險憑證號碼、駕籍資料（如駕駛執照及其他）、車籍資料（如行車執照、廠牌型號、車牌號碼及其他）等。  </div>
                            <div className='subList'>- 其他使用者因使用本服務所產生之技術數據，例如：IP 地址、登錄時間、位置資料、財務交易資訊以及其他得以辨識個人休閒活動及興趣、生活格調等之資料。</div>
                        </li>
                      </ol>
                      <p>（上述資料之類別，法定編號包含：C〇〇一 辨識個人者、C〇〇二 辨識財務者、C〇〇三 政府資料中之辨識者、C〇一一 個人描述、C〇三五 休閒活動及興趣、C〇三六 生活格調、C〇三九 執照或其他許可、C〇九三 財務交易）  </p>

                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">三、 個人資料利用之期間、地區、對象及方式</div> {/* Maintenance title */}
                      <div className="text-list">
                      <p>本公司收集到的資料，將做如下處理：</p>
                      <ol>
                        <li>1. 您所提供的基本個人資料（如姓名），將做為會員身分判定的依據；您所提供的信用卡卡號，將作為提供服務優惠資訊的依據。  </li>
                        <li>2. 您的使用資料及技術資料，將作為改進本服務內容用。  </li>
                        <li>3. 您的個人資料將提供本公司及合作廠商進行個人化行銷服務之用。本公司將透過行動推播或寄送電子郵件之方式，分享本公司及合作廠商之優惠消息。您於接受本服務時，已表示您的同意，若您不希望收到本公司及合作廠商之優惠消息，可能導致您無法繼續使用本服務。  </li>
                        <li>4. 資訊授權
                          <div className='subList'>- 本公司將在履行會員服務的必要範圍內，將您部分或全部的個人資料，提供予第三方服務提供者進行處理。於此情形，本公司將採取行動以確保第三方服務提供者遵守個人資料保護法，包括適當地評估第三方服務提供者之資格與能力，於與第三方服務提供者之相關合約中訂定保密條款，並建立適當的資訊管理系統。本公司得提供第三方服務者處理之範圍，應以本服務條款中已經明示，且與本服務相關之項目為限，包含停車業者、行車周邊服務供應商、信用卡發行機構、銀行或與第三方支付服務業者。  </div>
                          <div className='subList'>- 本公司可能與第三方共用綜合性的非個人資料。「綜合性非個人資料」是指記錄有關用戶分組收集的資料，這些資料在經過分組後不再反映或指向某個特定的可被辨識的使用者。上述資訊之處理與利用，可能由本公司之關係企業或其他合作夥伴進行，或於台灣外發生。除非有當地法律除外情況，本公司不會將這些資訊用做其他用途。本公司亦不會未經會員事先同意向第三者透露其個人資料，但因國家重大利益或為配合執法機關調查而根據法律而需要透露者則除外。  </div>
                        </li>
                        <li>5. 您的個人資料，將於本公司實際營運本服務的地區內，進行處理與利用。前述處理與利用之方式，將以數據化、自動化的方法為之。  </li>
                        <li>6. 上述之資料除綜合性非個人資料外，本公司得蒐集、處理或利用您個人資料的期間，自您開始使用本服務之時，至您終止使用本服務時，或本公司停止向您供應本服務時為止（以時間較早者為準）。</li>
                      </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">四、個人資料的自主權</div> {/* Maintenance title */}
                      <div className="text-list">
                        <ol>
                          <li>1. 您本人可查詢、複製、或閱覽屬於您的個人資料，若非本人或於本公司尚未查證您為本人前，您不得申請查詢、複製、請求閱覽不屬於本帳號之個人資料及帳號服務。如非前述情況之申請者，必要時您將提供相關個人資料及書面資訊，使本公司可協助處理作業程序。  </li>
                          <li>2. 如您的個人資料有所遺漏或錯誤，您得隨時請求本公司進行補充或更正。  </li>
                          <li>3. 您本人可要求停止蒐集、處理、利用或刪除屬於您的個人資料；惟您若要求本公司停止蒐集、處理、利用或刪除您的個人資料，可能造成本公司無法對您提供本服務部分或全部之內容，於此情況下，本公司得視具體情況，終止與您之間的服務條款。  </li>
                          <li>4. 於妨害國家重大利益、妨害公務機關執行法定職務、妨害蒐集機關或第三人重大利益時，本公司有權拒絕您主動提出變更、刪除或異動個人資料之請求。</li>
                        </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">五、個人資料的安全</div> {/* Maintenance title */}
                      <div className="text-list">
                        <ol>
                          <li>1. 為保護您的隱私，本公司提供必要之技術及措施保護個人資料。您的個人資料、註冊帳號及密碼等，請您妥善保管，避免外洩。您的信用卡資料，請您妥善保管，避免為他人之不法用途。您同意在註冊成為本服務會員時所留存的資料與事實相符，如嗣後發現你的個人資料遭他人非法使用或有任何異常時，應立即通知本公司暫停本服務並採取防範措施（如暫停您的帳號權限、變更您的密碼），本公司將協助您調查釐清您的登入帳號是否遭受冒用或盜用。您同意於使用本服務時，所提供及使用之資料皆為合法，並無侵害第三人權利、違反第三方協議或涉及任何違法行為。如因使用本服務而致第三人損害，除本公司故意或重大過失外，本公司並不負擔相關賠償責任。  </li>
                          <li>2. 因您需輸入正確的手機、電子郵件始能加入會員並查看個人資訊 （如帳號之名稱、手機號碼和電子郵件等個人資訊），前述個人資訊並非與支付工具相關之高風險資訊（如信用卡卡號和驗證資料等高風險資訊），故當您在本服務進行登入時，本公司並未將您的姓名、暱稱、手機號碼和電子郵件等資訊進行遮蔽，以利您得透過前揭資訊確認於特定介面所輸入之資料是否正確，惟您應自行確保您使用的裝置、設備和相關登入資訊的安全，以防止他人窺視、非法使用、取得您的登入資訊、竄改基本身分資料、毀損您的紀錄等。</li>
                        </ol>
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">六、隱私權及個人資料保護政策的修訂與效力</div> {/* Maintenance title */}
                      <div className="text-list">
                        <ol>
                          <li>1. 本公司將不定時更新本政策，並遵循中華民國隱私權與個人資料保護相關法令。</li>
                          <li>2. 本政策構成服務條款的一部分。</li>
                          <li>3. 如您不同意本政策之任何條款或修改變更之內容，請您於公告修改後的3日內，向本公司提出異議或終止使用本服務之請求，逾期不提出且繼續使用本服務（包含但不限於繼續使用 10 Parking LINE@）者，視為同意更新的條款內容。</li>
                          <li>4. 如果您對本公司的隱私權或個人資料保護政策有任何問題，請聯絡 <a href="mailto:parkingservice@10parking.com">parkingservice@10parking.com</a></li>
                        </ol>
                      </div>
                    </div>
                  </li>
                  {/* complete all list */}
                </ul>
              </div>
            </div>
        </section>
      </section>
    </>
  );
}

export default RefundPolicy;